import { useDeviceType } from '@cian/ui-kit';
import React, { PropsWithChildren } from 'react';
import cn from 'classnames';

import * as styles from './styles.css';

const ShareWithRealtorModalLayoutHeader: React.FC<PropsWithChildren> = props => {
  const deviceType = useDeviceType();

  return <div className={cn(styles['header'], styles[deviceType])}>{props.children}</div>;
};

const ShareWithRealtorModalLayoutContent: React.FC<PropsWithChildren> = props => {
  const deviceType = useDeviceType();

  return <div className={cn(styles['content'], styles[deviceType])}>{props.children}</div>;
};

export const ShareWithRealtorModalLayout = {
  Content: ShareWithRealtorModalLayoutContent,
  Header: ShareWithRealtorModalLayoutHeader,
};
